import React, {useState} from 'react';
import {goMainRoute} from '../../helpers/auth';
import '../../views/login/login.sass';
import LoginForm from '../../views/login/loginForm';
import * as Yup from 'yup';
import useStore from '../../hooks/use-store';
import useRemoveMinWidthRestrictionWhileMounted from 'src/hooks/use-remove-min-width-restriction-while-mounted';

const LoginContainer = () => {
  const {store} = useStore();
  const {auth} = store;

  const schema = Yup.object().shape({
    email: Yup.string()
      .required(),
    password: Yup.string()
      .min(4)
      .required(),
  });

  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const clear = () => {
    setError(false);
  };

  const submitLogin = async (data) => {
    setError(false);
    setLoading(true);
    try {
      await auth.signIn(data);
      setLoading(false);
      goMainRoute(auth.profile);
    } catch (e) {
      console.log(e);
      setLoading(false);
      setError(true);
    }
  };

  useRemoveMinWidthRestrictionWhileMounted();

  return <LoginForm
    loading={loading}
    schema={schema}
    onLogin={submitLogin}
    error={error}
    clear={clear}
  />;
};


export default LoginContainer;
